import Colors from '@utils/Colors.js'

import {radius} from '../styles.js'
import {formSpacing} from '../forms/styles.js'

// The overlays (Modal, Popup, PdfModal) take their look from here. The stacking order is
// zIndex in ../styles.ts. Change a value here instead of in a component.

export const modalStyle = {
    backdrop: 'rgba(0, 0, 0, 0.6)',
    background: Colors.backgroundNeutral,
    radius: radius.default,
    padding: 12,
    // The panel is top-aligned with this space above and below it, a long one scrolls along with the backdrop
    margin: 20,
    width: '80%',
    maxWidth: 800,
    // Below the header (title and close button)
    headerGap: 24,
    closeIconColor: Colors.buttonSolid,
    // Between the buttons in ModalActions
    actionsGap: formSpacing.columnGap
}

export const popupStyle = {
    // Width of a Popup with only text, with inputs and with a list of errors. question: narrow, but 80% of a phone
    // screen (the look of the yes/no questions of the courier app), for openBoolean's width option
    width: {narrow: 400, inputs: 600, errors: 800, question: 'min(80%, 400px)'},
    // Up to this part of a small screen (the courier app)
    maxWidth: '90%',
    // Below the text
    textGap: 30,
    // The buttons at the bottom, so short labels like Ja and Nee are easy to tap
    buttonMinWidth: 80,
    // Below the buttons above the list (buttonTop, setActionButtons) and the inputs
    blockGap: 24,
    // Below every alert in an AlertStack and the progress bar
    alertGap: 6,
    progressGap: 16,
    // Below the message under the progress bar
    progressMessageGap: 8,
    optionsMaxHeight: 600
}
